'use strict';

import '@babel/polyfill';
// import Swiper from 'swiper';
import { ua } from './view/_ua';
import { header } from './view/_header';
import { modal } from './view/_modal';
import { height } from './view/_height';
// import { chart } from './view/_chart';
// import { smoothScroll } from './view/_smoothScroll';
import { scroll } from './view/_scroll';
// import { filter } from './view/_filter';
import { accordion } from './view/_accordion';

// import { slider } from './view/_slider';
// import { toggle } from './view/_toggle';
// import { linkText } from './view/_linkText';
